import { httpPost } from './request/index'

/* 积分管理 */
// 积分列表
export function getData (data) {
  return httpPost('/integral/rule/getList', data)
}
// 详情
export function getInfo (data) {
  return httpPost('/integral/rule/getInfo?id=' + data.id, {})
}
// 添加\编辑
export function addAndEdit (data) {
  return httpPost('/integral/rule/addOrEditIntegralRule', data)
}
// 查询小区
export function getStreet (data) {
  return httpPost('/integral/rule/getStreet', data)
}

/* 积分排行 */
export function rankGetData (data) {
  return httpPost('/memberUser/getUserInfo', data)
}

/* 分类次数排行 */
export function deliveryRank (data) {
  return httpPost('/memberUser/getDeliveryRank', data)
}

/* 新增资产排行 */
export function newRanking (data) {
  return httpPost('/memberUser/newRanking', data)
}

/* 点位运营列表 */
export function getRegionByProduct (data) {
  return httpPost('/product/getRegionByProduct', data)
}

/* 点位运营-获取设备列表 */
export function getProduct (data) {
  return httpPost('/product/getProduct', data)
}

/* 点位运营-获取设备健康详情 */
export function getProductDetail (data) {
  return httpPost('/product/getProductDetail', data)
}

// 工作台搜索
export function getHousingEstateList (data = {}) {
  return httpPost('/estate/getHousingEstateList', data)
}
// 工作台总数指标
export function getDetailedCount (data = {}) {
  return httpPost('/indexPage/getDetailedCount', data)
}

// 工作台总数指标
export function getAreaList (data = {}) {
  return httpPost('/login/user/getAreasByUserId', data)
}

// 运营管理》点位运营
export function getProductDetails (data = {}) {
  return httpPost('/product/getProductDetails', data)
}

// 运营管理》点位运营>满意度
export function getScoreStatistics (data = {}) {
  return httpPost('/data/getScoreStatistics', data)
}

// 运营管理》点位运营>最新运营监管图片
export function getOperationPhoto (data = {}) {
  return httpPost('/product/getOperationPhoto', data)
}
